// extracted by mini-css-extract-plugin
export var growableInput = "_9k-0";
export var tagContainer = "_9k-2";
export var textInput = "_9k-1";